import React from 'react'
import CIcon from '@coreui/icons-react'
import { cibFlipboard, cibPinboard, cilBell, cilCalculator, cilCalendar, cilChartPie, cilClipboard, cilCode, cilCursor, cilDescription, cilDrop, cilLevelUp, cilList, cilNoteAdd, cilNotes, cilOptions, cilPencil, cilPuzzle, cilSpeedometer, cilStar, cilTruck, cilUser, } from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react'

const ManagerSideBarNavData = [
  {
    component: CNavItem,
    name: '홈',
    to: '.',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavTitle,
    name: '스토어',
  }, {
    component: CNavItem,
    name: '상점 등록',
    to: 'store/register',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: '상점 관리',
    to: 'store/management',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: '미승인 상점 관리',
    to: 'store/confirmYnManagement',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: '계약서 관리',
    to: 'store/contract',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavTitle,
    name: '정산',
  },
  {
    component: CNavItem,
    name: '스토어별 정산',
    to: 'settlement',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: '월별 정산 내역',
    to: 'detailedSettlement',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavTitle,
    name: '성인인증 통계',
  },
  {
    component: CNavItem,
    name: '성인인증 통계',
    to: 'verificationStats',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavTitle,
    name: '상품',
  },

  {
    component: CNavItem,
    name: '상품 목록',
    to: 'product/list',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: '상품등록',
    icon: <CIcon icon={cilNoteAdd} customClassName="nav-icon" />,

    items: [
      {
        component: CNavItem,
        name: '일반 등록',
        to: 'product/register',
      }
    ],
  },
  {
    component: CNavTitle,
    name: '브랜드',
  },
  {
    component: CNavItem,
    name: '브랜드 등록',
    to: 'brand/register',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: '브랜드 관리',
    to: 'brand/list',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },

  {
    component: CNavTitle,
    name: '카테고리',
  },
  // {
  //   component: CNavItem,
  //   name: '카테고리 목록',
  //   to: 'category/list',
  //   icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  // },
  {
    component: CNavItem,
    name: '카테고리 생성',
    to: 'category/create',
    icon: <CIcon icon={cilNoteAdd} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: '카테고리 관리',
    to: 'category/register',
    icon: <CIcon icon={cilNoteAdd} customClassName="nav-icon" />,
  },
  {
    component: CNavTitle,
    name: '점주',
  },
  // {
  //   component: CNavItem,
  //   name: '발주요청내역',
  //   to: 'vendor/orderRequests',
  //   icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  // },
  // {
  //   component: CNavItem,
  //   name: '자동발주내역',
  //   to: 'vendor/autoOrdering',
  //   icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  // },
  {
    component: CNavItem,
    name: '점주 판매요율 관리',
    to: 'vendor/salesRate',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: '점주 목록',
    to: 'vendor/list',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: '문의 목록',
    to: 'vendor/inquire/list',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: '점주 등록',
    icon: <CIcon icon={cilNoteAdd} customClassName="nav-icon" />,

    items: [
      {
        component: CNavItem,
        name: '점주 등록',
        to: 'vendor/register',
      }
    ],
  },
  {
    component: CNavTitle,
    name: '파트너스',
  },
  {
    component: CNavItem,
    name: '파트너스 등록',
    icon: <CIcon icon={cilNoteAdd} customClassName="nav-icon" />,
    to: 'partners/register',
  },
  {
    component: CNavTitle,
    name: '자판기',
  },
  {
    component: CNavItem,
    name: '기기등록',
    to: 'vending/register',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  // {
  //   component: CNavItem,
  //   name: '기기관리',
  //   to: 'vending/list',
  //   icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  // },
  {
    component: CNavItem,
    name: '기기매핑',
    to: 'vending/mapping',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  // {
  //   component: CNavItem,
  //   name: '기기관리',
  //   to: 'vending/list',
  //   icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  // }
  // {
  //   component: CNavTitle,
  //   name: '기획전',
  // },
  // {
  //   component: CNavItem,
  //   name: '기획전 등록',
  //   to: 'exhibition/register',
  //   icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  // },
  // {
  //   component: CNavItem,
  //   name: '기획전 관리',
  //   to: 'exhibition/list',
  //   icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  // },
  {
    component: CNavTitle,
    name: 'IOT',
  },
  {
    component: CNavItem,
    name: 'IOT 관리',
    to: 'iot/home',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },



]
export default ManagerSideBarNavData;
